var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterBottle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    fillRule: "evenodd",
    d: "M9.312 30.5c-.68 0-1.23-.522-1.23-1.165 0-.642.55-1.163 1.23-1.163h5.622V12.873l-3.387-4.676a1.12 1.12 0 01-.215-.658V2.55H6.383v4.99c0 .235-.075.464-.215.658L2.78 12.873v16.462c0 .643-.55 1.164-1.23 1.164-.68 0-1.23-.52-1.23-1.164V12.513c0-.235.075-.464.215-.658l3.388-4.676V1.385c0-.643.55-1.163 1.23-1.163h7.41c.679 0 1.23.52 1.23 1.163V7.18l3.386 4.676c.14.194.216.423.216.658v16.822c0 .643-.552 1.164-1.23 1.164H9.311z"
  })));
}
export default SvgWaterBottle;